export default __webpack_public_path__ + "static/john-4833357234b5044091178153c3b22e17.svg";